<template>
  <div :key="course.uuid" class="col-4 toc_panel" aria-label="Table of content section">
    <b-list-group v-if="allDataLoaded">
      <!-- Show Current State of TOC -->
      <div class="topic-list-item">

        <template v-if="Object.keys(currentAncestor).length > 0 && currentLevel > 0">
          <div :class="currentAncestor.uuid==currentEntityUuid?'toc_row row_1 sec_hd_1 active_row':'toc_row row_1 sec_hd_1'" :id="'nodeRow_' + currentAncestor.uuid">
            <b-link @click="clickAndExpandTopic(currentAncestor.uuid, currentAncestor.objectType); tocBack();" :id="'lnk_txt_' + currentAncestor.uuid" class="lnk_txt" :aria-label="currentAncestor.title + ' progress status is ' + progressStatusTitle(currentAncestor.uuid)">
              {{currentAncestor.title}}
            </b-link>
            <div class="row_status active">
              <span class="icon-progress" :class="progressClass(currentAncestor.uuid)" :title="progressStatusTitle(currentAncestor.uuid)" v-b-tooltip.hover></span>
            </div>
            <b-popover :target="'lnk_txt_' + currentAncestor.uuid" triggers="hover" placement="bottom" class="title_popup" :container="'nodeRow_TitleContainer' + currentAncestor.uuid">
              <div class="title_container">
                {{currentAncestor.title}}
              </div>
            </b-popover>
            <div :id="'nodeRow_TitleContainer' + currentAncestor.uuid" class="title_container_popup"></div>
          </div>
        </template>

        <template v-if="Object.keys(currentParent).length > 0 && currentLevel > 1">
          <div :class="currentParent.uuid==currentEntityUuid?'toc_row row_1 sec_hd_2 active_row':'toc_row row_1 sec_hd_2'" :id="'nodeRow_' + currentParent.uuid">
          <template v-if="!currentParent.locked">
            <b-link @click="clickAndExpandTopic(currentParent.uuid, currentParent.objectType); tocBack();" :id="'lnk_txt_' + currentParent.uuid" class="lnk_txt" :aria-label="currentParent.title + ' progress status is ' + progressStatusTitle(currentParent.uuid)">
              {{currentParent.title}}
            </b-link>
            </template>
            <template v-else>
            <b-link :id="'lnk_txt_' + currentParent.uuid" class="lnk_txt locked" :aria-label="currentParent.title + ' progress status is ' + progressStatusTitle(currentParent.uuid)">
              {{currentParent.title}}
            </b-link>
            <span class="ic-lock" :title="'Open after '+ currentParent.unlockReliantOnTitle[0]" v-b-tooltip.hover></span>
            </template>
            <div class="row_status active">
              <span class="icon-progress" :class="progressClass(currentParent.uuid)" :title="progressStatusTitle(currentParent.uuid)" v-b-tooltip.hover></span>
            </div>
            <b-popover :target="'lnk_txt_' + currentParent.uuid" triggers="hover" placement="bottom" class="title_popup" :container="'nodeRow_TitleContainer' + currentParent.uuid">
              <div class="title_container">
                {{currentParent.title}}
              </div>
            </b-popover>
            <div :id="'nodeRow_TitleContainer' + currentParent.uuid" class="title_container_popup"></div>
          </div>
        </template>
        <div class="lnk_back" v-if="currentLevel > 0">
          <b-link @click="tocBack()">< back</b-link>
        </div>
      </div>
      <!-- Show Current State of TOC Ends -->

  		<div class="content-scroll-column content_column_v23" :class="'tocLevel_' + currentLevel">
        <!-- Show all topics -->
        <template v-if="currentLevel === 0">
          <b-list-group-item class="topic-list-item" v-for="topic in topics" :key="topic.uuid">

  					<div class="toc_row row_1" :id="'nodeRow_' + topic.uuid" :class="{active_row: currentParentUuid === topic.uuid || currentEntityUuid === topic.uuid}">
  						<b-link @click="clickAndExpandTopic(topic.uuid, topic.objectType)">
  							<span :id="'lnk_txt_' + topic.uuid" class="lnk_txt" :aria-label="topic.title + ' progress status is ' + progressStatusTitle(topic.uuid)">{{topic.title}}</span>
  						</b-link>
              <span class="row_status" :class="{active: currentEntityUuid === topic.uuid}">
                <span class="icon-progress ace_sec_txt" :class="progressClass(topic.uuid)" :title="progressStatusTitle(topic.uuid)" v-b-tooltip.hover></span>
              </span>
              <b-popover :target="'lnk_txt_' + topic.uuid" triggers="hover" placement="bottom" class="title_popup" :container="'nodeRow_TitleContainer' + topic.uuid">
                <div class="title_container">
                  {{topic.title}}
                </div>
              </b-popover>
              <div :id="'nodeRow_TitleContainer' + topic.uuid" class="title_container_popup"></div>
  					</div>

  				</b-list-group-item>
        </template>

        <!-- Show all subtopics of topic selected -->
        <template v-if="currentLevel === 1">
          <b-list-group-item class="topic-list-item" v-for="subtopic in currentAncestor.subtopics" :key="subtopic.uuid">
            <div class="toc_row row_3 top-level-assets" :class="{active_row: currentParentUuid === subtopic.uuid || currentEntityUuid === subtopic.uuid}" :id="'tc_' + subtopic.uuid" v-if="subtopic.objectType === 'LearningContent'">
              <b-link v-if="subtopic.type === 'ASSESSMENT' || subtopic.type === 'SCORM' || subtopic.type === 'RICH_HTML'" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }">
                <span class="ic_container">
                  <span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
                  <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                  <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL"></span>
                </span>
                <span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" :aria-label="subtopic.title + ' progress status is ' + progressStatusTitle(subtopic.uuid)">{{subtopic.title}}</span>
              </b-link>
              <b-link v-if="subtopic.type !== 'ASSESSMENT' && subtopic.type !== 'SCORM' &&  subtopic.type !== 'RICH_HTML'" :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: subtopic.objectType, entityUuid: subtopic.uuid } }">
                <span class="ic_container">
                  <span v-if="subtopic.fileType === 'video'" class="icon icon-video"></span>
                  <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf"></span>
                  <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile float-left"></span>
                  <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text float-left"></span>
                  <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video float-left"></span>
                  <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip float-left"></span>
                  <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word"></span>
                  <span v-if="subtopic.fileType === 'ppt' || subtopic.fileType === 'pptx'" class="icon icon-pagePPT"></span>
                  <span v-if="subtopic.fileType === 'xlsx'" class="icon icon-file-excel"></span>
                  <span v-if="subtopic.fileType === 'other'" class="icon icon-pageURL"></span>
                  <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL"></span>
                  <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image"></span>
                </span>
                <span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" :aria-label="subtopic.title + ' progress status is ' + progressStatusTitle(subtopic.uuid)">{{subtopic.title}}</span>
              </b-link>
              <span class="row_status" :class="{active: currentParentUuid === subtopic.uuid}">
                <span class="icon-progress" :class="progressClass(subtopic.uuid)" :title="progressStatusTitle(subtopic.uuid)" v-b-tooltip.hover></span>
              </span>
              <b-popover :target="'lnk_txt_' + subtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subtopic.uuid">
                <div class="title_container">
                  {{subtopic.title}}
                </div>
              </b-popover>
              <div :id="'nodeRow_TitleContainer' + subtopic.uuid" class="title_container_popup"></div>

            </div>
            <div :class="subtopic.locked ? 'entity_locked':''">
              <div class="toc_row row_2" :id="'nodeRow_' + subtopic.uuid" v-if="subtopic.objectType !== 'LearningContent'" :class="{active_row: currentParentUuid === subtopic.uuid || currentEntityUuid === subtopic.uuid}">
                <template v-if="!subtopic.locked">
                <b-link @click="clickAndExpandTopic(subtopic.uuid, subtopic.objectType)">
                  <span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" :aria-label="subtopic.title" v-on:click="expandCollapseTreeNode(subtopic.uuid)">{{subtopic.title}}</span>
                </b-link>
                </template>
                <template v-else>
                <b-link class="locked">
                  <span :id="'lnk_txt_' + subtopic.uuid" class="lnk_txt" :aria-label="subtopic.title">{{subtopic.title}}</span>
                </b-link>
                <span class="ic-lock" :title="$tf('openOn') + ' ' + subtopic.unlockReliantOnTitle[0]" v-b-tooltip.hover></span>
                </template>
                <span class="row_status" :class="{active: currentParentUuid === subtopic.uuid}">
                  <span class="icon-progress ace_sec_txt" :class="progressClass(subtopic.uuid)" :title="progressStatusTitle(subtopic.uuid)" v-b-tooltip.hover></span>
                </span>
                <b-popover :target="'lnk_txt_' + subtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subtopic.uuid">
                  <div class="title_container">
                    {{subtopic.title}}
                  </div>
                </b-popover>
                <div :id="'nodeRow_TitleContainer' + subtopic.uuid" class="title_container_popup"></div>
              </div>
            </div>
          </b-list-group-item>
        </template>

        <!-- Show all subtopics of topic selected -->
        <template v-if="currentLevel === 2 && !currentParent.locked">
          <b-list-group-item class="topic-list-item" v-for="subsubtopic in currentParent.subtopics" :key="subsubtopic.uuid">
            <div class="toc_row row_3" :class="{active_row: currentEntityUuid === subsubtopic.uuid}" :id="'tc_' + subsubtopic.uuid">
              <b-link v-if="subsubtopic.type === 'ASSESSMENT' || subsubtopic.type === 'SCORM' || subsubtopic.type === 'RICH_HTML'" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid } }" >
                <span class="ic_container">
                  <span v-if="subsubtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
                  <span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL"></span>
                  <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                </span>
                <span :id="'lnk_txt_' + subsubtopic.uuid" class="lnk_txt" :aria-label="subsubtopic.title + ' progress status is ' + progressStatusTitle(subsubtopic.uuid)">{{subsubtopic.title}}</span>
              </b-link>
              <b-link v-if="subsubtopic.type !== 'ASSESSMENT' && subsubtopic.type !== 'SCORM' && subsubtopic.type !== 'RICH_HTML'" :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: subsubtopic.objectType, entityUuid: subsubtopic.uuid } }" >
                <span class="ic_container">
                  <span v-if="subsubtopic.fileType === 'video'" class="icon icon-video" ></span>
                  <span v-if="subsubtopic.fileType === 'pdf'" class="icon icon-file-pdf" ></span>
                  <span v-if="subsubtopic.fileType === 'csv'" class="icon icon-csvFile float-left"></span>
                  <span v-if="subsubtopic.fileType === 'txt'" class="icon icon-file-text float-left"></span>
                  <span v-if="subsubtopic.fileType === 'mp4' || subsubtopic.fileType === 'mp3'" class="icon icon-video float-left"></span>
                  <span v-if="subsubtopic.fileType === 'zip'" class="icon icon-file-zip float-left"></span>
                  <span v-if="subsubtopic.fileType === 'doc' || subsubtopic.fileType === 'docx'" class="icon icon-file-word" ></span>
                  <span v-if="subsubtopic.fileType === 'ppt' || subsubtopic.fileType === 'pptx'" class="icon icon-pagePPT" ></span>
                  <span v-if="subsubtopic.fileType === 'xlsx'" class="icon icon-file-excel" ></span>
                  <span v-if="subsubtopic.fileType === 'html'" class="icon icon-pageURL" ></span>
                  <span v-if="subsubtopic.fileType === 'other'" class="icon icon-pageURL" ></span>
                  <span v-if="subsubtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                  <span v-if="subsubtopic.fileType === 'externalurl'" class="icon icon-pageURL" ></span>
                  <span v-if="subsubtopic.fileType === 'jpg' || subsubtopic.fileType === 'jpeg' || subsubtopic.fileType === 'png' || subsubtopic.fileType === 'gif'" class="icon icon-image" ></span>
                </span>
                <span :id="'lnk_txt_' + subsubtopic.uuid" class="lnk_txt" :aria-label="subsubtopic.title + ' progress status is ' + progressStatusTitle(subsubtopic.uuid)">{{subsubtopic.title}}</span>
              </b-link>
              <span class="row_status">
                <span class="icon-progress" :class="progressClass(subsubtopic.uuid)" :title="progressStatusTitle(subsubtopic.uuid)" v-b-tooltip.hover></span>
              </span>
              <b-popover :target="'lnk_txt_' + subsubtopic.uuid" triggers="hover" placement="top" class="title_popup" :container="'nodeRow_TitleContainer' + subsubtopic.uuid">
                <div class="title_container">
                  {{subsubtopic.title}}
                </div>
              </b-popover>
              <div :id="'nodeRow_TitleContainer' + subsubtopic.uuid" class="title_container_popup"></div>
            </div>
          </b-list-group-item>
        </template>
  		</div>
    </b-list-group>

    <stretch v-if="!allDataLoaded"></stretch>
  </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import VClamp from 'vue-clamp'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'table-of-contents',
  props: ['uuid'],
  components: {
    VClamp,
    Stretch
  },
  data: () => {
    return {
      selectedRow: undefined,
      status_css: {
        10: 'noGrade',
        0: 'gradeE',
        1: 'gradeD',
        2: 'gradeC',
        3: 'gradeB',
        4: 'gradeA'
      },
      progress_state: {0: 'not_started', 1: 'in_progress', 2: 'completed', 3: 'failed'},
      progressClasses: {},
      resourse_status: {0: 'noGrade', 1: 'in_progress', 2: 'gradeA', 3: 'failed'},
      statusClasses: {},
      currentLevel: 0,
      currentEntity: {},
      currentEntityUuid: '',
      currentParent: {},
      currentParentUuid: '',
      currentAncestor: {},
      currentAncestorUuid: '',
      allDataLoaded: false
    }
  },

  created () {
  },

  mounted () {
    this.loadCourseTopicsInfo()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCourseTopics',
      'loadCourseCompetencies'
    ]),

    async loadCourseTopicsInfo () {
      if (this.course && this.course.uuid) {
        this.allDataLoaded = false
        await this.loadCourseTopics({uuid: this.course.uuid, loadDataFromServer: true})
        this.setupToc()
        this.allDataLoaded = true
      }
    },
    reset () {
      this.currentParent = {}
      this.currentAncestor = {}
      this.currentEntity = {}
      this.currentLevel = 0
    },

    clickAndExpandTopic (topicUuid, topicObjectType) {
      this.currentEntityUuid = topicUuid
      this.setupToc()
      return this.$router.push({ name: 'entityDetail', params: { uuid: this.course.uuid, entityType: topicObjectType, entityUuid: topicUuid }})
    },

    async setupToc () {

      this.reset()
      this.loadStatusClasses()

      if (this.course.courseType === 'SUGGESTION_PLUS_BASED') {
        await this.loadCourseTopics({uuid: this.course.uuid, loadDataFromServer: true})
      }

      // Compute currentEntity, currentTopic & currentSubTopic
      let currentEntity = this.topicsMap[this.currentEntityUuid]

      if (currentEntity) {
        this.currentEntity = currentEntity

        let currentParent = this.topicsMap[currentEntity.ancestor]
        if (currentParent) {
          this.currentParent = currentParent
          this.currentParentUuid = currentParent.uuid

          let currentAncestor = this.topicsMap[currentParent.ancestor]
          if (currentAncestor) {
            this.currentAncestor = currentAncestor
            this.currentAncestorUuid = currentAncestor.uuid
          }
        }

        if (Object.keys(this.currentParent).length > 0 && Object.keys(this.currentAncestor).length > 0) {
          this.currentLevel = 2
        } else if (Object.keys(this.currentParent).length > 0) {
          if (this.currentEntity.objectType === 'LearningTopic') {
            this.currentLevel = 2
            this.currentAncestor = this.currentParent
            this.currentParent = this.currentEntity
          } else {
            this.currentAncestor = this.currentParent
            this.currentLevel = 1
          }
        } else if (Object.keys(this.currentParent).length === 0 && Object.keys(this.currentAncestor).length === 0) {
          this.currentAncestor = this.currentEntity
          this.currentLevel = 1
        }
        this.scrollToC()
      }
    },

    scrollToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      if ($scrollTo) {
        $container.animate({scrollTop: ($scrollTo.offset().top - $container.offset().top + $container.scrollTop()), scrollLeft: 0}, 300)
      }
    },

    /*
     * this method is used to go one level up in the TOC
     */
    tocBack () {
      if (this.currentLevel > 0) {
        this.currentLevel -= 1
      }
      setTimeout(() => {
        var $container = $('.content-scroll-column')
        if (this.currentLevel === 0) {
          var $scrollTo = $('#nodeRow_' + this.currentAncestor.uuid)
        } else if (this.currentLevel === 1) {
          var $scrollTo = $('#nodeRow_' + this.currentParent.uuid)
        }
        $container.animate({scrollTop: ($scrollTo.offset().top - $container.offset().top + $container.scrollTop())}, 300)
      }, 100)
    },

    loadStatusClasses () {
      var status = 10
      var performance = 0
      if (this.courseCompetencies && this.courseCompetencies.length > 0) {
        for (var i = 0; i < this.courseCompetencies.length; i++) {
          var competency = this.courseCompetencies[i]
          if (competency) {
            status = competency.status
            this.progressClasses[competency.entityId] = this.progress_state[status]
            if ((competency.competencyType === 'RESOURCE') || ((competency.competencyType === 'SCORM') && !competency.performance)) {
              this.statusClasses[competency.entityId] = this.resourse_status[status]
            } else {
              performance = competency.performance
              if (performance !== null) {
                $('#prog_' + competency.entityId).html(performance.toFixed(2) + '%')
                if (performance >= 90) {
                  status = 4
                } else if (performance >= 80 && performance < 90) {
                  status = 3
                } else if (performance >= 65 && performance < 80) {
                  status = 2
                } else if (performance >= 40 && performance < 65) {
                  status = 1
                } else if (performance < 40) {
                  status = 0
                }
              } else {
                status = 10
              }
              this.statusClasses[competency.entityId] = this.status_css[status]
            }
          }
        }
      }
    },

    statusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    resourseStatusClass (entityId) {
      if (entityId in this.statusClasses) {
        return this.statusClasses[entityId]
      } else {
        return 'noGrade'
      }
    },

    progressClass (entityId) {
      if (entityId in this.progressClasses) {
        return this.progressClasses[entityId]
      } else {
        return 'not_started'
      }
    },

    progressStatusTitle (entityId) {
      if (entityId in this.progressClasses) {
        if (this.progressClasses[entityId] == 'in_progress') {
          return 'In Progress'
        } else if (this.progressClasses[entityId] == 'not_started') {
          return 'Not Started'
        } else {
          return this.progressClasses[entityId]
        }
      } else {
        return 'Not Started'
      }
    }

  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entityUuid': state => state.course.entityUuid,
      'topics': state => state.course.topics,
      'topicsMap': state => state.course.topicsMap,
      'courseCompetencies': state => state.course.competencies
    })
  },

  watch: {
    entityUuid (newEntityUuid) {
      // Re-setup TOC
      if (newEntityUuid !== this.currentEntityUuid) {
        this.currentEntityUuid = newEntityUuid
        this.setupToc()
      }
    },
    'course.uuid' (newCourseUuid) {
      this.loadCourseTopicsInfo()
    }
  }
}
</script>

<style scoped>

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/TableOfContents.vue